/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC } from "react";
import { DialogService } from "../../../dialogs/DialogService";
import { DialogHost } from "./DialogHost";
import { useStateWithEvent } from "../../hooks";

export interface IDialogProviderProps {
	dialogService: DialogService;
}

export const DialogProvider: FC<IDialogProviderProps> = ({ dialogService }) => {
	const entries = useStateWithEvent(dialogService?.onEntriesChange, () =>
		dialogService?.getEntries()?.slice()
	);

	return (
		<>
			{entries.map((entry) => (
				<DialogHost key={entry.id} entry={entry} />
			))}
		</>
	);
};
